
const Convertdate = (item) => {
    if (!item) return "N/A";
  
    const toDate = new Date(item);
  
    const readableDate = toDate.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, 
    });
  
    return readableDate;
  };
  
  export default Convertdate;
  